import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO
        title="Not found"
        description="The page you requested does not exist on Spain Smile Guide."
        path="/404"
      />
      <section className="container-prose py-32 text-center">
        <div className="eyebrow mb-6">404</div>
        <h1 className="font-serif text-display text-ink">
          This page is not on file.
        </h1>
        <p className="mx-auto mt-6 max-w-lg text-ink/80">
          The publication is small and evergreen. If you were looking for
          something specific, start with the{" "}
          <Link to="/methodology">methodology</Link> or the{" "}
          <Link to="/how-to-choose-a-smile-makeover-clinic-in-spain">
            decision framework
          </Link>
          .
        </p>
        <p className="mt-10">
          <Link to="/" className="font-sans text-small">
            Return to the front page &rarr;
          </Link>
        </p>
      </section>
    </>
  );
}
